import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { createProvider } from "./vue-apollo";
import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
import "./plugins/vuetify-mask.js";
// eslint-disable-next-line no-unused-vars
import finalSubmitSystem from "./mixins/finalSubmitSystem";


Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: "AIzaSyAZpnFIkebY_b-A1R0aRmr7oESGlg2euW0",
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount("#app");
